import { Grid2, Typography } from '@mui/material'
import React from 'react'
import mission from "../../../assets/Home/misssion.png"
import vision from "../../../assets/Home/vision.jpg"
import "../About.css"

export function AboutVisionDesktop() {
  return (
    <Grid2 justifyContent="space-around" className="vm-container info">
        <Grid2 container className="missioncontainer">
            <img width="200px" sx={{ backgroundBlendMode:"multiply"}} src={mission} alt="" />
           <Grid2 className="missiondata">
            <Typography className="missionheading" sx={{fontWeight:"600"}}> OUR MISSION</Typography>
            <Typography className="missiontext">Lorem ipsum dolor sit, amet consectetur adipisicing elit. A eaque pariatur labore esse libero omnis quod quisquam soluta sequi, nemo impedit facere totam aut tempora eius amet incidunt dolore nisi?</Typography>
           </Grid2> 
        </Grid2>
        <Grid2 container className="visioncontainer">
        <img width="200px" sx={{ backgroundBlendMode:"multiply"}} src={vision} alt="" />
           <Grid2 className="visiondata">
            <Typography className="visionheading" sx={{fontWeight:"600"}}> OUR VISION</Typography>
            <Typography className="visiontext">Lorem ipsum dolor sit, amet consectetur adipisicing elit. A eaque pariatur labore esse libero omnis quod quisquam soluta sequi, nemo impedit facere totam aut tempora eius amet incidunt dolore nisi?</Typography>
           </Grid2> 
        </Grid2>
    </Grid2>
  )
}

 